export const formatToLocalTime = (isoString, options = undefined) => {
  if (!isoString) {
    return 'N/A';
  }
  try {
    // Ensure the string is treated as UTC if it doesn't have timezone info.
    const date = new Date(isoString.endsWith('Z') || isoString.includes('+') ? isoString : `${isoString}Z`);
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      // Return the original string if it's not a valid date, as it might be a different kind of string.
      return isoString;
    }
    // `undefined` for the locale makes it use the browser's default locale.
    return date.toLocaleString(undefined, options);
  } catch (error) {
    console.error("Error formatting date:", error);
    return 'Invalid Date';
  }
};
